import React from 'react';
import WeeklySalesChart from '../components/Dashboard/WeeklySalesChart';
import BalanceReport from '../components/Dashboard/BalanceReport';

const Dashboard = () => (
    <div className="container mx-auto px-3 py-4 sm:px-0 sm:py-0">
        <WeeklySalesChart />
        <BalanceReport />
    </div>
);

export default Dashboard; 